<template>
  <div>
    <!-- 步骤 start -->
    <div v-if="step === 1 || step === 2" class="steps">
      <div class="steps-inline steps-top">
        <img v-if="step === 1" :src="activeIcon" class="steps-symbol" />
        <img v-else :src="cofirmIcon" class="steps-symbol" />
        <div class="steps-line">
          <span class="steps-progress" />
        </div>
        <img v-if="step === 2" :src="activeIcon" class="steps-symbol" />
        <img v-else :src="inactiveIcon" class="steps-symbol" />
      </div>
      <div class="steps-inline steps-bottom">
        <div
          class="steps-txt"
          :style="{ color: step === 1 ? '#FF8900' : '#666666' }"
        >
          基本信息
        </div>
        <div class="steps-txt">经营情况</div>
      </div>
    </div>
    <!-- 步骤 end -->
    <!-- 宣传页 start -->
    <div v-if="step === 0" class="activity">
      <div class="activity-page">
        <img
          src="https://static3.yishouapp.com/obs/tools/def/2022/10/7/90e534fa54df683b6a866d65b1f61778.jpeg"
          alt=""
          class="activity-photo"
        />
        <div class="activity-box">
          <van-button
            type="primary"
            color="#FCAB3E"
            block
            class="activity-btn"
            @click="handleJump"
            >我要入驻
          </van-button>
        </div>
      </div>
    </div>
    <!-- 宣传页 end -->
    <!-- 基本信息 start -->
    <van-form
      v-else-if="step === 1"
      :show-error-message="true"
      error-message-align="right"
      label-width="76"
      @submit="handleNext"
    >
      <van-cell-group class="field-box">
        <van-field
          v-model="infoData.contract"
          placeholder="请输入联系人"
          input-align="right"
          maxlength="10"
          clearable
          required
          :rules="[
            { required: true, message: '请填写联系人' },
            { pattern: patternName, message: '联系人需为汉字' },
          ]"
        >
          <span slot="label" class="field-label">联系人</span>
        </van-field>
        <van-field
          v-model="infoData.mobile"
          required
          type="tel"
          placeholder="请填写11位手机号"
          input-align="right"
          maxlength="11"
          clearable
          :rules="[
            { pattern: mobile, message: '请填写正确的手机号' },
            {
              validator: asyncValidMobile,
              message: '手机号已有入驻记录，请更换手机号提交',
              trigger: 'onBlur',
            },
          ]"
        >
          <span slot="label" class="field-label">手机号</span>
        </van-field>
        <van-field
          v-model="infoData.company"
          required
          placeholder="请输入"
          input-align="right"
          maxlength="40"
          clearable
          :rules="[{ required: true, message: '请填写公司名称' }]"
        >
          <span slot="label" class="field-label">公司名称</span>
        </van-field>
      </van-cell-group>
      <van-cell-group class="field-box">
        <van-field
          v-model="companyAddress"
          label-width="140"
          required
          disabled
          placeholder="请选择"
          input-align="right"
          right-icon="https://static1.yishouapp.com/oss/tools/def/2021/4/19/ce51ef5596880331895647d716f50c6a.png"
          :rules="[{ required: true, message: '请选择公司所在地区' }]"
          @click="handleAddress('company')"
        >
          <span slot="label" class="field-label">公司所在地区</span>
        </van-field>
        <van-field
          v-model="infoData.company_address"
          required
          name="company_address"
          placeholder="请输入详细地址"
          input-align="right"
          maxlength="100"
          clearable
          :rules="[{ required: true, message: '请填写公司地址' }]"
        >
          <span slot="label" class="field-label">公司地址</span>
        </van-field>
      </van-cell-group>
      <van-cell-group class="field-box">
        <van-field
          v-model="storeAddress"
          label-width="140"
          required
          disabled
          placeholder="请选择"
          input-align="right"
          right-icon="https://static1.yishouapp.com/oss/tools/def/2021/4/19/ce51ef5596880331895647d716f50c6a.png"
          :rules="[{ required: true, message: '请选档口所在地区' }]"
          @click="handleAddress('store')"
        >
          <span slot="label" class="field-label">档口所在地区</span>
        </van-field>
        <van-field
          v-model="infoData.stall_address"
          required
          name="stall_address"
          placeholder="请输入详细地址"
          input-align="right"
          maxlength="100"
          clearable
          :rules="[{ required: true, message: '请填写档口地址' }]"
        >
          <span slot="label" class="field-label">档口地址</span>
        </van-field>
        <!-- <van-field
                    v-model="infoData.stall_address"
                    required
                    placeholder="请输入详细地址"
                    input-align="right"
                    maxlength="100"
                    :rules="[{ required: true, message: '请填写档口地址' }]"
                >
                    <span slot="label" class="field-label">档口地址</span>
                </van-field> -->
      </van-cell-group>
      <van-cell-group class="field-box" style="margin-bottom: 86px">
        <van-field name="uploader" required :border="false" disabled>
          <span slot="label" class="field-label">营业执照</span>
        </van-field>
        <van-field name="uploader" input-align="center">
          <template #input>
            <div class="field-uploader">
              <van-uploader
                ref="business"
                v-model="business"
                name="business"
                :after-read="afterRead"
                :before-read="beforeRead"
                accept="image/png, image/jpeg"
                :max-count="1"
                :deletable="false"
                preview-size="90"
              >
                <img :src="uploadIcon" alt="" srcset="" class="upload-icon" />
              </van-uploader>
              <van-button
                v-if="isBusiness"
                round
                plain
                color="#FCAB3E"
                size="mini"
                @click.prevent="handleBusiness"
                >重新上传
              </van-button>
              <span class="field-txt">照片应小于5M的，支持jpg，png格式</span>
            </div>
          </template>
        </van-field>
      </van-cell-group>
      <div class="next-btn">
        <van-button
          type="primary"
          color="#FCAB3E"
          native-type="submit"
          block
          style="border-radius: 8px"
          >下一步
        </van-button>
      </div>
    </van-form>
    <!-- 基本信息 end -->
    <!-- 经营情况 start -->
    <van-form v-else error-message-align="right" @submit="handleSubmit">
      <van-cell-group class="field-box">
        <van-field
          v-model="business_types_txt"
          required
          placeholder="请选择"
          input-align="right"
          :right-icon="arrow"
          readonly
          clickable
          :rules="[{ required: true }]"
          @click="handlePopup('business_types')"
        >
          <span slot="label" class="field-label">经营类型</span>
        </van-field>
        <van-field
          v-model="styles_txt"
          required
          type="tel"
          placeholder="请选择"
          input-align="right"
          :right-icon="arrow"
          readonly
          clickable
          :rules="[{ required: true }]"
          @click="handlePopup('styles')"
        >
          <span slot="label" class="field-label">风格</span>
        </van-field>
        <van-field
          v-model="categories_txt"
          required
          placeholder="请选择"
          input-align="right"
          :right-icon="arrow"
          readonly
          clickable
          :rules="[{ required: true }]"
          @click="handlePopup('categories')"
        >
          <span slot="label" class="field-label">类目</span>
        </van-field>
        <van-field
          v-model="main_categories_txt"
          required
          placeholder="请选择"
          input-align="right"
          :right-icon="arrow"
          readonly
          clickable
          :rules="[{ required: true }]"
          @click="handleCate('main_categories')"
        >
          <span slot="label" class="field-label">主营品类</span>
        </van-field>
        <van-field
          v-model="seasons_txt"
          required
          placeholder="请选择"
          input-align="right"
          :right-icon="arrow"
          readonly
          clickable
          :rules="[{ required: true }]"
          @click="handlePopup('seasons')"
        >
          <span slot="label" class="field-label">主打季节</span>
        </van-field>
        <van-field
          v-model="own_factory_nums_txt"
          label-width="120"
          required
          placeholder="请选择"
          input-align="right"
          :right-icon="arrow"
          readonly
          clickable
          :rules="[{ required: true }]"
          @click="handlePopup('own_factory_nums')"
        >
          <span slot="label" class="field-label">自有工厂数量</span>
        </van-field>
        <van-field
          v-model="oem_factory_nums_txt"
          label-width="120"
          required
          placeholder="请选择"
          input-align="right"
          :right-icon="arrow"
          readonly
          clickable
          :rules="[{ required: true }]"
          @click="handlePopup('oem_factory_nums')"
        >
          <span slot="label" class="field-label">外包工厂数量</span>
        </van-field>
      </van-cell-group>
      <van-cell-group class="field-box">
        <van-field label-width="100" required>
          <span slot="label" class="field-label">开发能力</span>
          <template #input>
            <van-radio-group
              v-model="infoData.dev_ability"
              direction="horizontal"
            >
              <van-radio :name="1">
                有
                <template #icon="props">
                  <img
                    class="field-radio-icon"
                    :src="props.checked ? radioActiveIcon : radioInactiveIcon"
                  />
                </template>
              </van-radio>
              <van-radio :name="2">
                无
                <template #icon="props">
                  <img
                    class="field-radio-icon"
                    :src="props.checked ? radioActiveIcon : radioInactiveIcon"
                  />
                </template>
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field label-width="100" required>
          <span slot="label" class="field-label">无理由退换货</span>
          <template #input>
            <van-radio-group
              v-model="infoData.no_reason_return"
              direction="horizontal"
            >
              <van-radio :name="1">
                支持
                <template #icon="props">
                  <img
                    class="field-radio-icon"
                    :src="props.checked ? radioActiveIcon : radioInactiveIcon"
                  />
                </template>
              </van-radio>
              <van-radio :name="2">
                不支持
                <template #icon="props">
                  <img
                    class="field-radio-icon"
                    :src="props.checked ? radioActiveIcon : radioInactiveIcon"
                  />
                </template>
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field label-width="100" required>
          <span slot="label" class="field-label">电商经营经验</span>
          <template #input>
            <van-radio-group
              v-model="infoData.is_ecommerce_operate_experience"
              direction="horizontal"
            >
              <van-radio :name="1">
                有
                <template #icon="props">
                  <img
                    class="field-radio-icon"
                    :src="props.checked ? radioActiveIcon : radioInactiveIcon"
                  />
                </template>
              </van-radio>
              <van-radio :name="2">
                无
                <template #icon="props">
                  <img
                    class="field-radio-icon"
                    :src="props.checked ? radioActiveIcon : radioInactiveIcon"
                  />
                </template>
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="
            infoData.is_ecommerce_operate_experience ===
            ECOMMERCE_OPERATE_EXPERIENCE_TYPE.HAS
          "
          v-model="ecommerce_operate_platform"
          label-width="100"
          required
          placeholder="请选择"
          input-align="right"
          :right-icon="arrow"
          readonly
          clickable
          :rules="[
            {
              required: true,
            },
          ]"
          @click="handlePopup('ecommerce_operate_platform')"
        >
          <span slot="label" class="field-label">电商经营平台</span>
        </van-field>
        <van-field
          v-model="infoData.annual_sales"
          type="digit"
          label-width="120"
          required
          placeholder="请填写"
          input-align="right"
          maxlength="7"
          clearable
          :rules="[
            { required: true, message: '请填写年销售额' },
            {
              validator: asyncValidMoney,
              message: '请填写正确的数字',
            },
          ]"
        >
          <span slot="label" class="field-label"
            >年销售额<span class="field-unit">（万元）</span></span
          >
        </van-field>
        <van-field
          v-model="infoData.month_new_num"
          type="digit"
          label-width="120"
          required
          placeholder="请填写"
          input-align="right"
          maxlength="7"
          clearable
          :rules="[
            { required: true, message: '请填写月上新数' },
            {
              validator: asyncValidMoney,
              message: '请填写正确的数字',
            },
          ]"
        >
          <span slot="label" class="field-label"
            >月上新数<span class="field-unit">（件）</span></span
          >
        </van-field>
        <van-field
          v-model="infoData.designer_num"
          type="digit"
          label-width="120"
          required
          placeholder="请填写"
          input-align="right"
          maxlength="7"
          clearable
          :rules="[
            { required: true, message: '请填写设计师团队人数' },
            {
              validator: asyncValidMoney,
              message: '请填写正确的数字',
            },
          ]"
        >
          <span slot="label" class="field-label">设计师团队人数</span>
        </van-field>
      </van-cell-group>
      <van-cell-group class="field-box">
        <van-field
          name="uploader"
          label-width="80"
          required
          :border="false"
          disabled
        >
          <span slot="label" class="field-label">
            经营视频
            <span class="field-desc">请上传&#60;10s的视频，支持mp4</span>
          </span>
        </van-field>
        <van-field name="uploader" input-align="center">
          <template #input>
            <div class="field-uploader">
              <p class="field-title">
                <span class="field-icon">*</span>办公室视频
              </p>
              <!-- :before-read="beforeReadVideo" -->
              <van-uploader
                ref="office"
                v-model="officeList"
                name="office"
                accept="video/*"
                :after-read="afterReadOffice"
                preview-size="90"
                :deletable="false"
                :max-count="1"
              >
                <img :src="uploadIcon" alt="" srcset="" class="upload-icon" />
                <template #preview-cover>
                  <div
                    class="preview-cover van-ellipsis"
                    @click="handlePlay('office')"
                  >
                    <video :src="officeUrl" alt="" />
                    <div class="video-box" />
                  </div>
                </template>
              </van-uploader>
              <van-button
                v-if="isOffice"
                round
                plain
                color="#FCAB3E"
                size="mini"
                @click.prevent="handleOffice"
                >重新上传
              </van-button>
            </div>
            <div class="field-uploader">
              <p class="field-title">
                <span class="field-icon">*</span>工厂视频
              </p>
              <van-uploader
                ref="factory"
                v-model="factoryList"
                name="factory"
                accept="video/*"
                :max-count="1"
                :after-read="afterReadFactory"
                preview-size="90"
                :deletable="false"
              >
                <img :src="uploadIcon" alt="" srcset="" class="upload-icon" />
                <template #preview-cover>
                  <div
                    class="preview-cover van-ellipsis"
                    @click="handlePlay('factory')"
                  >
                    <video :src="factoryUrl" alt="" />
                    <div class="video-box" />
                  </div>
                </template>
              </van-uploader>
              <van-button
                v-if="isFactory"
                round
                plain
                color="#FCAB3E"
                size="mini"
                @click.prevent="handleFactory"
                >重新上传
              </van-button>
            </div>
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group class="field-box" style="margin-bottom: 86px">
        <van-field
          name="uploader"
          label-width="140"
          required
          :border="false"
          disabled
        >
          <span slot="label" class="field-label">
            产品报价（元）
            <span class="field-desc">請上传5张产品图片，以及对应报价</span>
          </span>
        </van-field>
        <van-field
          name="uploader"
          input-align="center"
          :border="false"
          :show-error-message="false"
        >
          <template #input>
            <div class="field-uploader">
              <van-uploader
                v-model="productFirst"
                name="first"
                :after-read="afterRead"
                :before-read="beforeRead"
                accept="image/png, image/jpeg"
                :max-count="1"
                preview-size="94"
              >
                <img :src="uploadIcon" alt="" srcset="" class="upload-icon" />
              </van-uploader>
              <div class="popover">
                <span class="popover-arrow" />
                <span class="popover-label"
                  ><span class="field-icon">*</span>报价：</span
                >
                <!-- maxlength="6" -->
                <van-field
                  v-model="infoData.product_price1"
                  type="number"
                  label="￥"
                  :label-class="labelClass"
                  placeholder="请输入"
                  style="padding: 0 6px"
                  :rules="[
                    {
                      required: true,
                      message: '请填写报价',
                    },
                    { validator: asyncValidator },
                  ]"
                />
              </div>
            </div>
            <div class="field-uploader">
              <van-uploader
                v-model="productSecond"
                name="second"
                :after-read="afterRead"
                :before-read="beforeRead"
                accept="image/png, image/jpeg"
                :max-count="1"
                preview-size="94"
              >
                <img :src="uploadIcon" alt="" srcset="" class="upload-icon" />
              </van-uploader>
              <div class="popover">
                <span class="popover-arrow" />
                <span class="popover-label"
                  ><span class="field-icon">*</span>报价：</span
                >
                <van-field
                  v-model="infoData.product_price2"
                  type="number"
                  label="￥"
                  :label-class="labelClass"
                  placeholder="请输入"
                  :rules="[
                    {
                      required: true,
                      message: '请填写报价',
                    },
                    { validator: asyncValidator },
                  ]"
                  style="padding: 0 6px"
                />
              </div>
            </div>
            <div class="field-uploader">
              <van-uploader
                v-model="productThird"
                name="third"
                :after-read="afterRead"
                :before-read="beforeRead"
                accept="image/png, image/jpeg"
                :max-count="1"
                preview-size="94"
              >
                <img :src="uploadIcon" alt="" srcset="" class="upload-icon" />
              </van-uploader>
              <div class="popover">
                <span class="popover-arrow" />
                <span class="popover-label"
                  ><span class="field-icon">*</span>报价：</span
                >
                <van-field
                  v-model="infoData.product_price3"
                  type="number"
                  label="￥"
                  :label-class="labelClass"
                  placeholder="请输入"
                  :rules="[
                    {
                      required: true,
                      message: '请填写报价',
                    },
                    { validator: asyncValidator },
                  ]"
                  style="padding: 0 6px"
                />
              </div>
            </div>
          </template>
        </van-field>
        <van-field name="uploader" :border="false">
          <template #input>
            <div class="field-uploader">
              <van-uploader
                v-model="productFourth"
                name="fourth"
                :after-read="afterRead"
                :before-read="beforeRead"
                accept="image/png, image/jpeg"
                :max-count="1"
                preview-size="94"
              >
                <img :src="uploadIcon" alt="" srcset="" class="upload-icon" />
              </van-uploader>
              <div class="popover">
                <span class="popover-arrow" />
                <span class="popover-label"
                  ><span class="field-icon">*</span>报价：</span
                >
                <van-field
                  v-model="infoData.product_price4"
                  type="number"
                  label="￥"
                  :label-class="labelClass"
                  placeholder="请输入"
                  :rules="[
                    {
                      required: true,
                      message: '请填写报价',
                    },
                    { validator: asyncValidator },
                  ]"
                  style="padding: 0 6px"
                />
              </div>
            </div>
            <div class="field-uploader">
              <van-uploader
                v-model="productFifth"
                name="fifth"
                :after-read="afterRead"
                :before-read="beforeRead"
                accept="image/png, image/jpeg"
                :max-count="1"
                preview-size="94"
              >
                <img :src="uploadIcon" alt="" srcset="" class="upload-icon" />
              </van-uploader>
              <div class="popover">
                <span class="popover-arrow" />
                <span class="popover-label"
                  ><span class="field-icon">*</span>报价：</span
                >
                <van-field
                  v-model="infoData.product_price5"
                  type="number"
                  label="￥"
                  :label-class="labelClass"
                  placeholder="请输入"
                  :rules="[
                    {
                      required: true,
                      message: '请填写报价',
                    },
                    { validator: asyncValidator },
                  ]"
                  style="padding: 0 6px"
                />
              </div>
            </div>
          </template>
        </van-field>
      </van-cell-group>
      <div class="btn-wrapper">
        <!-- <van-button type="info" native-type="button" hairline @click="handleReturn"
                    >返回上一步</van-button
                > -->
        <a href="javascript:;" class="return-btn" @click="handleReturn"
          >返回上一步</a
        >
        <button
          type="info"
          class="submit-btn"
          color="#FCAB3E"
          native-type="submit"
        >
          确定提交
        </button>
      </div>
    </van-form>
    <!-- 经营情况 end -->

    <!-- 地址选择器 start -->
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :area-list="areaList"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
    <!-- 地址选择器 end -->
    <!-- 分类选择器 start -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :title="titleMap[titleStatus]"
        :columns="columnList[titleStatus]"
        value-key="label"
        :default-index="1"
        @confirm="handleChange"
      >
      </van-picker>
    </van-popup>
    <!-- 分类选择器 end -->
    <van-popup v-model="catePicker" position="bottom">
      <van-picker
        :title="titleMap[titleStatus]"
        show-toolbar
        :columns="columnList[titleStatus]"
        value-key="label"
        :default-index="1"
        @confirm="handleConfirm"
      ></van-picker>
    </van-popup>
    <!-- 视频 start -->
    <van-popup v-model="isVideo" @click-overlay="handleClose">
      <div id="xgplay" />
    </van-popup>
    <video ref="videoPlay_first" :src="officeVideo" style="display: none" />
    <video ref="videoPlay_second" :src="factoryVideo" style="display: none" />
    <!-- 视频 end -->

    <!-- 验证码 start -->
    <!-- show-confirm-button  :before-close="beforeClose" -->
    <van-dialog v-model="isVerify" title="验证" :show-confirm-button="false">
      <van-form :show-error-message="false" @submit="handleSubmit">
        <van-field
          v-model="infoData.verify_code"
          placeholder="请输入验证码"
          :rules="[{ required: true, message: '请填写验证码' }]"
        >
          <template #button>
            <van-image
              width="100"
              height="50"
              :src="verifyImg"
              @click="handleResult"
            />
          </template>
        </van-field>
        <div>
          <van-button
            round
            block
            color="#F6992A"
            type="info"
            size="small"
            native-type="submit"
            style="width: 80%; margin: 12px auto"
            >提交
          </van-button>
        </div>
      </van-form>
    </van-dialog>
    <!-- 验证码 end -->

    <!-- 上传文件表单 start -->
    <form
      ref="inputForm"
      :action="`http://${obsInfo.bucket_name}.${obsInfo.endpoint}/${obsInfo.path}`"
      method="post"
      enctype="multipart/form-data"
      style="display: none"
    >
      <!-- 对象名 -->
      <input type="text" name="key" value="objectname" />
      <!-- 对象ACL权限 -->
      <input type="text" name="x-obs-acl" value="public-read" />
      <!-- 对象MIME类型 -->
      <input type="text" name="content-type" value="text/plain" />
      <!-- policy的base64编码值 -->
      <input type="hidden" name="policy" :value="obsInfo.policy" />
      <!-- AK -->
      <input type="hidden" name="AccessKeyId" :value="obsInfo.access_key_id" />
      <!-- 签名串信息 -->
      <input type="hidden" name="signature" :value="obsInfo.signature" />
      <input ref="inputFile" name="file" type="file" />
      <input ref="InputUplaod" name="submit" value="Upload" type="submit" />
    </form>
    <!-- 上传文件表单 end -->
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import Compressor from "compressorjs";
import { Toast, Dialog } from "vant";
import "@vant/touch-emulator";
import Player from "xgplayer/dist/core_player.js";
import play from "xgplayer/dist/controls/play.js";
import fullscreen from "xgplayer/dist/controls/fullscreen.js";
import progress from "xgplayer/dist/controls/progress.js";
import volume from "xgplayer/dist/controls/volume.js";
import pip from "xgplayer/dist/controls/pip.js";
import flex from "xgplayer/dist/controls/flex.js";
import axios from "axios";
import md5 from "md5";
import { sendDynamic } from "@/util/data-report.js";
import { setTitle } from "@/util/local-yishou-util.js";
import callNative from "@/util/callNative.js";
import * as merchants from "@/api/merchants.js";
// 电商经营经验{1：有；2：无}
const ECOMMERCE_OPERATE_EXPERIENCE_TYPE = {
  HAS: 1,
  NO: 2,
};

// 电商经营平台{1：1688、2：淘宝、3：拼多多、4：抖音、5：天猫、6：小红书、7：其他}
const ECOMMERCE_OPERATE_PLATFORM_OPTIONS = [
  { label: "1688", value: 1 },
  { label: "淘宝", value: 2 },
  { label: "拼多多", value: 3 },
  { label: "抖音", value: 4 },
  { label: "天猫", value: 5 },
  { label: "小红书", value: 6 },
  { label: "其他", value: 7 },
];
export default {
  name: "MerchantsPage",
  components: {},
  data() {
    return {
      ECOMMERCE_OPERATE_EXPERIENCE_TYPE,
      ECOMMERCE_OPERATE_PLATFORM_OPTIONS,
      step: 0,
      arrow:
        "https://static1.yishouapp.com/oss/tools/def/2021/4/19/307b747be4e9a47818a2ad68e5867d46.png",
      activeIcon:
        "https://static1.yishouapp.com/oss/tools/def/2021/4/22/fd44aaaeca658031c254eba342194818.png",
      cofirmIcon:
        "https://static1.yishouapp.com/oss/tools/def/2021/5/6/7feb1e48e46f81f096c84a27323229c4.png",
      inactiveIcon:
        "https://static1.yishouapp.com/oss/tools/def/2021/4/16/6abd4e23e9049e384e0583959e2ebdc1.png",
      radioActiveIcon:
        "https://static1.yishouapp.com/oss/tools/def/2021/4/19/a70c076c12f6344b9074a2eb7e8d80e0.png",
      radioInactiveIcon:
        "https://static1.yishouapp.com/oss/tools/def/2021/4/19/8f4c3f37587bb0fb74b139ee07e143b8.png",
      uploadIcon:
        "https://static1.yishouapp.com/oss/tools/def/2021/4/22/e9264e3eba841e5d1a3f144238bfd37d.png",
      labelClass: "labelClass",
      business: [],
      // 是否显示营业执照上传图标
      isBusiness: false,
      obsInfo: {},
      infoData: {
        // 来源
        source: Number(this.$route.query.source) || 0,
        // 联系人
        contract: "",
        // 手机号
        mobile: "",
        // 公司名称
        company: "",
        // 公司所在省份
        company_province: "",
        // 公司所在城市
        company_city: "",
        // 公司所在区
        company_district: "",
        // 公司所在地址
        company_address: "",
        // 档口信息相关
        stall_province: "",
        stall_city: "",
        stall_district: "",
        stall_address: "",
        license_pic: "",
        // 经营类型
        business_type: "",
        // 风格
        style: "",
        // 类目
        category: "",
        // 主营品类
        main_category: "",
        // 主打季节
        season: "",
        // 自有工厂数
        own_factory_num: "",
        // 外包工厂数
        oem_factory_num: "",
        // 开发能力
        dev_ability: 1,
        // 无理由退换货
        no_reason_return: 1,
        // 年销售额
        annual_sales: "",
        // 月上新数
        month_new_num: "",
        // 设计师团队人数
        designer_num: "",
        // 办公室视频
        office_video: "",
        // 工厂视频
        factory_video: "",
        // 产品图相关
        product_pic1: "",
        product_price1: "",
        product_pic2: "",
        product_price2: "",
        product_pic3: "",
        product_price3: "",
        product_pic4: "",
        product_price4: "",
        product_pic5: "",
        product_price5: "",
        // 验证码
        verify_code: "",
        token: "",
        is_ecommerce_operate_experience: 1, // 电商经营经验
        ecommerce_operate_platform: "", // 电商经营平台
      },
      patternName: /^(?:[\u4e00-\u9fa5·]{1,10})$/,
      mobile: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
      // 地址json
      areaList,
      // 是否展示地址选择器
      showArea: false,
      // 公司地址文本
      companyAddress: "",
      // 档口地址文本
      storeAddress: "",
      // 当前地址选择器状态
      addressStatus: "",
      showPicker: false,
      catePicker: false,
      titleMap: {
        business_types: "选择经营类型",
        styles: "选择风格",
        categories: "选择类目",
        main_categories: "主营品类",
        seasons: "主打季节",
        own_factory_nums: "自有工厂数",
        oem_factory_nums: "外包工厂数",
        ecommerce_operate_platform: "电商经营平台",
      },
      titleStatus: "",
      // 选择项
      columnList: {
        business_types: [],
        styles: [],
        categories: [],
        main_categories: [],
        seasons: [],
        own_factory_nums: [],
        oem_factory_nums: [],
        ecommerce_operate_platform: ECOMMERCE_OPERATE_PLATFORM_OPTIONS,
      },
      // 选中文本
      business_types_txt: "",
      styles_txt: "",
      categories_txt: "",
      main_categories_txt: "",
      seasons_txt: "",
      own_factory_nums_txt: "",
      oem_factory_nums_txt: "",
      ecommerce_operate_platform: "",
      // 文件暂存
      fileTemp: {},
      // 区分上传文件的种类
      uploadType: "",
      // 办公环境
      officeList: [],
      // 工厂环境
      factoryList: [],
      // 办公环境预览图
      officeUrl: "",
      // 工厂环境预览图
      factoryUrl: "",
      // 是否显示重新上传
      isOffice: false,
      isFactory: false,
      // 视频 base64;
      officeVideo: null,
      factoryVideo: null,
      // 是否展示视频对话框
      isVideo: false,
      productFirst: [],
      productSecond: [],
      productThird: [],
      productFourth: [],
      productFifth: [],
      // 是否显示验证码
      isVerify: false,
      // 验证码图片
      verifyImg: "",
      // 是否禁用视频上传
      player: null,
      fileInfo: null,
    };
  },
  created() {
    sendDynamic("cluesToBeSupplier", "索引h5成为供应商", {
      click_source: "曝光",
    });
    setTitle("成为供应商");
  },
  mounted() {
    // this.verifyCode();
    // this.getAliobsInfo();
    // this.getTypeList();
  },
  methods: {
    /**
     * 入驻
     */
    handleJump() {
      setTitle("我要入驻");
      sendDynamic("cluesToBeSupplier", "索引h5成为供应商", {
        click_source: "成为供应商曝光",
      });
      sendDynamic("cluesToBeSupplier", "索引h5成为供应商", {
        click_source: "基本信息",
      });
      const ua = navigator.userAgent.toLowerCase();
      const version = ua.match(/cpu iphone os (.*?) like mac os/);
      if (version) {
        if (parseFloat(version[1].replace("_", ".")) < 10) {
          Toast({
            message:
              "当前手机系统版本过低，请升级手机系统版本或更换手机进行入驻",
            duration: 5000,
          });
        } else {
          this.step = 1;
          this.getAliobsInfo();
        }
      } else {
        this.step = 1;
        this.getAliobsInfo();
      }
      // console.log ("你当前的Ios系统版本为：", version[1].replace('_','.'))
    },
    /**
     * 获取 oss 相关密钥
     */
    getAliobsInfo() {
      merchants
        .getObsUploadData()
        .then((res) => {
          this.obsInfo = { ...res.uptoken };
          this.obsInfo.bucket_name = res.bucket_name;
          this.obsInfo.endpoint = res.endpoint;
          this.obsInfo.path = res.path;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    handleNext() {
      if (this.business.length === 0 && this.infoData.license_pic === "") {
        Toast("请上传营业执照");
      } else {
        this.step = 2;
        // 加载分类
        this.getTypeList();
        sendDynamic("cluesToBeSupplier", "索引h5成为供应商", {
          click_source: "经营情况",
        });
      }
    },
    /**
     * 选择地址
     */
    onConfirm(val) {
      switch (this.addressStatus) {
        case "company":
          this.companyAddress = val
            .filter((item) => !!item)
            .map((item) => item.name)
            .join("/");
          // 地址单个赋值
          this.infoData.company_province = val[0].name;
          this.infoData.company_city = val[1].name;
          this.infoData.company_district = val[2].name;
          break;
        case "store":
          this.storeAddress = val
            .filter((item) => !!item)
            .map((item) => item.name)
            .join("/");
          this.infoData.stall_province = val[0].name;
          this.infoData.stall_city = val[1].name;
          this.infoData.stall_district = val[2].name;
          break;
        default:
          break;
      }
      this.showArea = false;
    },
    /**
     * 区分当前的地址选择器
     */
    handleAddress(type) {
      this.showArea = true;
      this.addressStatus = type;
    },
    /**
     * 上传图片，并压缩
     */
    beforeRead(file, detail) {
      // 鉴别哪个上传组件
      this.uploadType = detail.name;

      const that = this;
      // let shape = {}
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: 0.2,
          drew(context, canvas) {
            context.fillStyle = "#fff";
            context.font = "2rem serif";
            // 增加水印
            context.fillText("", 20, canvas.height - 20);
            // shape = { width: canvas.width, height: canvas.height }
          },
          // 压缩成功
          success(result) {
            resolve();
            // that.uploadTest(result)
            that.uploadFile(result);
          },
          error(error) {
            reject();
            console.log("错误", error.message);
          },
        });
      });
    },
    afterRead(file, detail) {
      console.log("文件", file);
      console.log("详细", detail);
    },
    /**
     * 读取文件
     */
    afterReadOffice(data) {
      this.fileTemp = {};
      Toast.loading({
        message: "上传视频中...",
        forbidClick: true,
        duration: 0,
      });
      this.uploadType = "office";
      this.fileTemp = data;
      // this.videoUrl = data.content;
      this.officeVideo = data.content;
      // this.fileTemp.file.type === 'video/quicktime'
      // if (/\.(mov)$/.test(this.fileTemp.file.name)) {
      this.uploadFile(this.fileTemp.file);
      // } else {
      //   // 计算视屏时长
      //   let that = this;
      //   let video = this.$refs.videoPlay_first;
      //   video.play();
      //   video.onloadedmetadata = function () {
      //     that.getVideoTime();
      //   };
      // }
    },
    /**
     * 读取文件
     */
    afterReadFactory(data) {
      // console.log(data)
      Toast.loading({
        message: "上传视频中...",
        forbidClick: true,
        duration: 0,
      });
      this.uploadType = "factory";
      this.fileTemp = data;
      // this.videoUrl = data.content;
      this.factoryVideo = data.content;
      // 假设为 mov 格式，则直接上传
      // console.log(this.fileTemp.file.type)
      // this.fileTemp.file.type === 'video/quicktime'
      // if (/\.(mov)$/.test(this.fileTemp.file.name)) {
      this.uploadFile(this.fileTemp.file);
      // } else {
      //   let that = this;
      //   // 计算视屏时长
      //   let video = this.$refs.videoPlay_second;
      //   video.play();
      //   video.onloadedmetadata = function () {
      //     that.getVideoTime();
      //   };
      // }
    },
    /**
     * 计算视屏时长
     */
    getVideoTime() {
      const video =
        this.uploadType === "office"
          ? this.$refs.videoPlay_first.duration
          : this.$refs.videoPlay_second.duration;
      if (video > 10) {
        Toast("视频大小不能大于10s");
        if (this.uploadType === "office") {
          this.officeList = [];
        } else {
          this.factoryList = [];
        }
      } else {
        this.uploadFile(this.fileTemp.file);
      }
    },
    /**
     * 上传文件
     */
    uploadFile(file) {
      this.fileTemp.status = "uploading";
      this.fileTemp.message = "上传中...";
      return new Promise((resolve, reject) => {
        // 计算时间
        const time = new Date();
        const date = `${time.getFullYear()}${
          time.getMonth() + 1 < 9
            ? `0${time.getMonth().toString()}`
            : time.getMonth()
        }${time.getDate()}${time.getTime()}`;
        const { name } = file;
        const prev = md5(name.split(".")[0]);
        const next = name.split(".")[name.split(".").length - 1];
        const fileName = `${this.obsInfo.path}${date}_${prev}.${next}`;

        const formData = new FormData();
        formData.append("policy", this.obsInfo.policy);
        formData.append("AccessKeyId", this.obsInfo.access_key_id);
        formData.append("signature", this.obsInfo.signature);
        formData.append("domain", this.obsInfo.domain);
        formData.append(
          "success_action_status",
          this.obsInfo.success_action_status
        );
        formData.append("key", fileName);
        formData.append("content-type", file.type);
        formData.append("file", file);

        axios
          .request({
            url: `//${this.obsInfo.bucket_name}.${this.obsInfo.endpoint}/`,
            method: "post",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
            withCredentials: false,
          })
          .then((res) => {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(res.data, "text/xml");
            const tmpkey = xmlDoc.querySelector("Key").innerHTML;
            if (!tmpkey) return;
            const lastImgUrl = this.obsInfo.domain + tmpkey;
            resolve(lastImgUrl);
            this.fileTemp.status = "done";
            this.checkFile(lastImgUrl);
            console.log(lastImgUrl);
            Toast.clear();
            console.log(lastImgUrl);
          })
          .catch((error) => {
            if (this.uploadType === "office" || this.uploadType === "factory") {
              this.fileTemp.status = "failed";
              this.fileTemp.message = "上传失败";
              Toast.clear();
            }
            reject(error);
          });
      });
    },
    handleBusiness() {
      this.business = [];
      this.$nextTick(() => {
        this.$refs.business.chooseFile();
        this.isBusiness = false;
      });
    },
    handleOffice() {
      this.officeList = [];
      this.$nextTick(() => {
        this.$refs.office.chooseFile();
        this.isOffice = false;
      });
    },
    handleFactory() {
      this.factoryList = [];
      this.$nextTick(() => {
        this.$refs.factory.chooseFile();
        this.isFactory = false;
      });
    },

    /**
     * 获取分类
     */
    getTypeList() {
      merchants
        .getSelectOps()
        .then((res) => {
          this.columnList = {
            ...res,
            ecommerce_operate_platform: ECOMMERCE_OPERATE_PLATFORM_OPTIONS,
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handlePopup(type) {
      this.showPicker = true;
      this.titleStatus = type;
    },
    checkData(picker) {
      const mode = {
        business_types: () => {
          this.business_types_txt = picker.label;
          this.infoData.business_type = picker.value;
        },
        styles: () => {
          this.styles_txt = picker.label;
          this.infoData.style = picker.value;
        },
        categories: () => {
          this.categories_txt = picker.label;
          this.infoData.category = picker.value;
        },
        seasons: () => {
          this.seasons_txt = picker.label;
          this.infoData.season = picker.value;
        },
        own_factory_nums: () => {
          this.own_factory_nums_txt = picker.label;
          this.infoData.own_factory_num = picker.value;
        },
        oem_factory_nums: () => {
          this.oem_factory_nums_txt = picker.label;
          this.infoData.oem_factory_num = picker.value;
        },
        ecommerce_operate_platform: () => {
          this.ecommerce_operate_platform = picker.label;
          this.infoData.ecommerce_operate_platform = picker.value;
        },
        default: () => {},
      };

      const net = mode[`${this.titleStatus}`] || mode.default;
      net.call(this);
    },
    handleCate(type) {
      this.catePicker = true;
      this.titleStatus = type;
    },
    handleChange(value) {
      this.showPicker = false;
      this.checkData(value);
    },
    handleConfirm(value, index) {
      this.main_categories_txt = `${value[0]}/${value[1]}`;
      this.infoData.main_category = this.columnList.main_categories[
        index[0]
      ].children[index[1]].value;
      this.catePicker = false;
    },
    /**
     * 校验手机号是否有提交过
     */
    asyncValidMobile(val) {
      return new Promise((resolve) => {
        if (this.infoData.source === 1 || this.infoData.source === 2) {
          merchants
            .hasInput({ mobile: val })
            .then((res) => {
              console.log(typeof res.exist);
              if (res.exist === 0) {
                resolve(true);
              } else {
                resolve(false);
              }
            })
            .catch((error) => {
              console.log("错误", error);
            });
        } else {
          resolve();
        }
      });
    },
    asyncValidMoney(val) {
      return new Promise((resolve, reject) => {
        if (Number(val) > 1000000) {
          Toast("请填写小于或等于1000000的数字");
          reject();
        } else {
          resolve();
        }
      });
    },
    /**
     * 校验是否大于100000
     */
    asyncValidator(val) {
      return new Promise((resolve, reject) => {
        if (Number(val) <= 100000) {
          resolve();
        } else {
          Toast("请填写小于或等于100000的报价");
          reject();
        }
      });
    },
    checkFile(url) {
      const mode = {
        business: () => {
          this.infoData.license_pic = url;
          this.isBusiness = true;
        },
        office: () => {
          this.officeUrl = url;
          this.infoData.office_video = `${url}?vframe/jpg/offset/7/w/800/h/600`;
          this.isOffice = true;
          // console.log(this.officeUrl);
        },
        factory: () => {
          this.factoryUrl = url;
          this.infoData.factory_video = url;
          this.isFactory = true;
          // console.log(this.factoryUrl);
        },
        first: () => {
          this.infoData.product_pic1 = url;
        },
        second: () => {
          this.infoData.product_pic2 = url;
        },
        third: () => {
          this.infoData.product_pic3 = url;
        },
        fourth: () => {
          this.infoData.product_pic4 = url;
        },
        fifth: () => {
          this.infoData.product_pic5 = url;
        },
        default: () => {
          console.log("默认");
        },
      };

      const net = mode[`${this.uploadType}`] || mode.default;
      net.call(this);
    },
    /**
     * 提交数据
     */
    handleSubmit() {
      console.log(
        "is_ecommerce_operate_experience",
        this.infoData.is_ecommerce_operate_experience
      );
      // 无电商经营经验时，清空电商经营平台
      if (
        this.infoData.is_ecommerce_operate_experience ===
        ECOMMERCE_OPERATE_EXPERIENCE_TYPE.NO
      ) {
        this.infoData.ecommerce_operate_platform = "";
      }
      console.log("数据", this.infoData);
      Toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      console.log("提交", this.infoData);
      merchants
        .settleIn({ ...this.infoData })
        .then((res) => {
          console.log("成功", res);
          sendDynamic("cluesToBeSupplier", "索引h5成为供应商", {
            click_source: "资料提交成功",
          });
          Dialog.alert({
            title: "开店资料提交成功！",
            message: "平台运营将在2个工作日内与您取得联系",
            confirmButtonColor: "#FCAB3E",
          }).then(() => {
            // 假设为APP，则执行关闭webview原生事件
            if (this.infoData.source === 1 || this.infoData.source === 2) {
              callNative.closeWebView();
            }
          });
        })
        .catch((error) => {
          console.log(error);
          if (error.code === 401) {
            this.verifyCode();
          } else {
            Toast(`${error.msg}`);
          }
        });
    },
    /**
     * 验证框
     */
    verifyCode() {
      this.isVerify = true;
      this.handleResult();
    },
    /**
     * 重新请求验证码
     */
    handleResult() {
      merchants
        .getVerifyCode()
        .then((res) => {
          console.log(res);
          this.verifyImg = `data:image/png;base64,${res.verifyImg}`;
          this.infoData.token = res.token;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * 弹窗拦截
     */
    // beforeClose(action, done) {
    //     if (this.infoData.verify_code !== "") {
    //     }
    // },
    // triggerFunc(func) {
    //   if (typeof func === "function") {
    //     return func.bind(this);
    //   } else {
    //     console.warn(func + "is not a function!");
    //     return function () {};
    //   }
    // },
    /**
     *
     */
    handleCancel() {
      this.showPicker = false;
    },
    /**
     * 播放视频
     */
    handlePlay(type) {
      const url = type === "office" ? this.officeVideo : this.factoryVideo;
      this.isVideo = true;
      this.$nextTick(() => {
        this.player = new Player({
          id: "xgplay",
          url,
          controlPlugins: [play, fullscreen, progress, volume, pip, flex],
          controls: false,
          lang: "zh-cn",
          autoplay: false,
        });

        this.player.on("error", () => {
          Toast.fail("不支持播放此视频格式");
        });
      });
    },
    /**
     * 关闭视频
     */
    handleClose() {
      // 销毁视频播放实例
      this.player.destroy(true);
    },
    /**
     * 返回上一步
     */
    handleReturn() {
      // this.isReture = !this.isReture
      setTitle("我要入驻");
      this.step = 1;
    },
  },
};
</script>

<style lang="less">
body {
  background: #f2f4f5;
}

.activity {
  width: 750px;
  height: 100%;
}

.activity-page {
  overflow-x: hidden;
  overflow-y: scroll;
}

.activity-photo {
  width: 100%;
}

.activity-box {
  position: fixed;
  bottom: 0;
  background: #fff;
  padding: 30px;
}

.activity-btn {
  width: 690px;
  border-radius: 16px;
}

.steps-inline {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.steps-top {
  padding: 38px 220px 0 220px;
}

.steps-bottom {
  padding: 15px 190px 0 190px;
  margin-bottom: 24px;
}

.steps-symbol {
  width: 40px;
  height: 40px;
  font-size: 30px;
  color: #fff;
  background: #ccc;
  border-radius: 50%;
  text-align: center;
  line-height: 40px;
}

.steps-line {
  width: 58px;
  height: 2px;
  background: #dadada;
  position: relative;
}

.steps-progress {
  height: 2px;
  background-color: #fd89be;
  position: absolute;
  left: 0;
  top: 0;
}

.steps-txt {
  color: #999;
  font-size: 26px;
}

.field-box {
  margin: 16px 24px;
  // background: #fff;
  border-radius: 16px;
}

.field-label {
  font-size: 30px;
  font-weight: 600;
  color: #333333;
}

.field-uploader {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.field-txt {
  font-size: 24px;
  color: #999;
  padding-top: 40px;
}

.field-radio-icon {
  height: 36px;
}

.field-unit {
  font-size: 24px;
  color: #999;
}

.field-desc {
  width: 420px;
  height: 20px;
  display: block;
  font-size: 24px;
  color: #999;
}

.field-title {
  width: 280px;
  height: 40px;
  font-size: 24px;
  color: #333;
  text-align: center;
}

.field-icon {
  font-size: 24px;
  color: #f92323;
}

.popover {
  width: 190px;
  height: 113px;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 8px;
  position: relative;
  margin: 18px 12px 0 12px;
  display: flex;
  flex-direction: column;
}

.popover-arrow {
  display: block;
  position: absolute;
  top: -10px;
  transform: translate(95px, 0);

  &::before {
    content: "";
    border: 1px solid #ccc;
    background: #fff;
    box-sizing: border-box;
    transform: rotate(45deg);
    position: absolute;
    width: 10px;
    height: 10px;
    z-index: -1;
    border-bottom-color: transparent;
    border-right-color: transparent;
  }
}

.popover-label {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  text-align: left;
  padding-left: 14px;
  padding-top: 8px;
}

.labelClass {
  width: 24px;
  height: 40px;
  font-size: 24px;
  color: #666;
  line-height: 50px;
  margin-right: 6px;
}

.btn-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 24px;
  position: fixed;
  bottom: 0;
}

.upload-icon {
  width: 190px;
  height: 190px;
}

.picker-header {
  width: 100%;
  height: 40px;
  position: relative;
}

.picker-title {
  height: 40px;
  font-size: 28px;
  color: #666;
  line-height: 40px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}

.picker-btn {
  width: 54px;
  height: 40px;
  font-size: 26px;
  color: #999999;
  line-height: 40px;
  display: block;
  position: absolute;
  right: 34px;
}

.preview-cover {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 4px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
}

.video-box {
  width: 62px;
  height: 62px;
  background-image: url("https://static1.yishouapp.com/oss/tools/def/2021/4/24/e1426f12d8d05e77be94b7513487c6a7.png");
  background-size: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.video-content {
  width: 750px;
}

.return-btn {
  width: 212px;
  height: 96px;
  background: #ffffff;
  border: 1px solid #e7e7e7;
  border-radius: 16px;
  color: #333;
  font-size: 24px;
  text-align: center;
  line-height: 96px;
}

.submit-btn {
  width: 456px;
  height: 96px;
  margin-left: 32px;
  background: #fcab3e;
  border-radius: 16px;
  color: #fff;
  border: none;
}

.next-btn {
  margin: 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
